<template>
  <article>
    <div class="activity-feed af-blocked">
      <div>
        <div v-on:click="goToRally" class="af-rally-hero">
          <img style="max-height: 40px; float: left;" :src="content.attributes['rally-hero-url']">
        </div>
        <div class="af-rally-title">
          <a v-on:click="goToRally">{{ content.attributes['rally-title'] }}</a>
        </div>
      </div>
      <hr class="af-hr-rally-title"/>
      <div class="af-body">
        <BlockedContentNotice :user-id="originatorId" what="the full post" />
      </div>
      <div class="af-author-section">
        <div class="af-avatar">
          <ActivityFeedUserAvatar
              :pUserId="originatorId"
              :pSize="'25px'"
              :pRallyId="content.attributes['rally-id']"
              :pAvatarFile="content.attributes['originator-avatar-url']"
              :pUserFirstName="content.attributes['originator-first-name']"
              :pUserLastName="content.attributes['originator-last-name']"
          ></ActivityFeedUserAvatar>
        </div>
        <div class="af-author-info">
          <div class="af-author-name">
            Posted by
            {{ content.attributes['originator-first-name'] }} {{ content.attributes['originator-last-name'] }}
            (Blocked User)
            <BlockUserMenu :user-id="originatorId" :content-uid="content.attributes['activity-id']" />
          </div>
          <div class="af-posted-rally">
            in <u><a v-on:click="goToRally">{{ content.attributes['rally-title'] }}</a></u>
          </div>
          <div class="af-posted-when">
            {{ when }}
          </div>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import moment from "moment-timezone";
import { router } from "../../common";
import BlockedContentNotice from "../BlockedContentNotice.vue";
import BlockUserMenu from "../BlockUserMenu.vue";

// Activity-feed card for any item whose originator the viewer has blocked.
// ActivityFeedContent swaps this in for every content type, so the feed
// hides the post body (and title, which can carry the message) while
// keeping the rally/author shell so the item stays recognisable.
export default {
  name: "BlockedActivityFeedListed",
  components: { BlockedContentNotice, BlockUserMenu },
  props: ["id", "channelId", "content"],
  computed: {
    originatorId() {
      return this.content.attributes['originator-id'];
    },
    when() {
      return this.content ? moment(this.content.attributes["created-at"]).fromNow() : "";
    }
  },
  methods: {
    goToRally() {
      router.push(`/${this.content.attributes['rally-id']}/messages`);
    }
  }
};
</script>

<style scoped>
.af-author-name {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
</style>
